import React from "react";
import { Link } from "react-router-dom";
import CustomLink from "../../Layout/CustomLink";
import { Divider } from "antd";

const NavLinks = () => {
  const links = [
    {
      text: "Home",
      route: "/",
    },
    {
      text: "Contact Us",
      route: "/contact-us",
    },
    {
      text: "Gallery",
      route: "/gallery",
    },
    {
      text: "Reviews",
      route: "/reviews",
    },
  ];

  return (
    <div className="nav-links">
      {links.map((link, index) => {
        return (
          <div className="" style={{ alignItems: 'center' }} key={link.text}>
                <CustomLink propsStyle={{}} propsClass="" to={link.route}>{link.text}</CustomLink>
          </div>
        );
      })}
    </div>
  );
};
export default NavLinks;
